// src/pages/Admin/VotePage/hooks/useVoteFilters.js

import { useMemo, useState } from "react";

import {
  getVoteStatistics,
  normalizeVote,
} from "../utils/voteAdmin.utils";

export default function useVoteFilters(votes = []) {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");

  const normalizedVotes = useMemo(
    () => votes.map(normalizeVote),
    [votes],
  );

  const filteredVotes = useMemo(() => {
    const normalizedSearch = searchTerm
      .toLowerCase()
      .trim();

    return normalizedVotes
      .filter((vote) => {
        if (
          statusFilter !== "all" &&
          vote._status !== statusFilter
        ) {
          return false;
        }

        if (
          typeFilter !== "all" &&
          vote.type !== typeFilter
        ) {
          return false;
        }

        if (!normalizedSearch) {
          return true;
        }

        const searchableContent = [
          vote.title,
          vote.description,
          vote.type,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return searchableContent.includes(normalizedSearch);
      })
      .sort(
        (firstVote, secondVote) =>
          new Date(secondVote.start_time).getTime() -
          new Date(firstVote.start_time).getTime(),
      );
  }, [
    normalizedVotes,
    searchTerm,
    statusFilter,
    typeFilter,
  ]);

  const statistics = useMemo(
    () => getVoteStatistics(votes),
    [votes],
  );

  const hasActiveFilters =
    Boolean(searchTerm.trim()) ||
    statusFilter !== "all" ||
    typeFilter !== "all";

  const resetFilters = () => {
    setSearchTerm("");
    setStatusFilter("all");
    setTypeFilter("all");
  };

  return {
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
    filteredVotes,
    statistics,
    hasActiveFilters,
    resetFilters,
  };
}